import PropTypes from 'prop-types'
import React from 'react'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="content">
      <div className="inner">
        <h1>Hellscream Raiders</h1>
        <p>
          A Faerlina horde raiding guild that has been around since 2004.
          <br />
          Our focus is to build and maintain a healthy supportive community that
          lasts.
        </p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('about')
            }}
          >
            About
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('recruitment')
            }}
          >
            Recruitment
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('apply')
            }}
          >
            Apply
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
